import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { CardComponent } from '../../shared/components/card/card.component';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-billing-suspended',
  imports: [CardComponent, IconComponent, ButtonComponent, TranslatePipe],
  templateUrl: './billing-suspended.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './billing-suspended.component.css',
})
export class BillingSuspendedComponent {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  goToBilling(): void {
    this.router.navigate(['/settings/billing']);
  }

  logout(): void {
    this.authService.logout();
  }
}
